import type { TemplateDictionaryItem } from "./templateDictionaryItems";

export const vehicleOwnerTemplateDictionaryItems: TemplateDictionaryItem[] = [
  {
    title: "Client Vehicle Owner Name",
    variable: "clientVehicleOwnerName",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "Alex Rivera",
  },
  {
    title: "Client Vehicle Owner FirstName",
    variable: "clientVehicleOwnerFirstName",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "Alex",
  },
  {
    title: "Client Vehicle Owner LastName",
    variable: "clientVehicleOwnerLastName",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "Rivera",
  },
  {
    title: "Client Vehicle Owner Email",
    variable: "clientVehicleOwnerEmail",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "alex@example.com",
  },
  {
    title: "Client Vehicle Owner Phone",
    variable: "clientVehicleOwnerPhone",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "(555) 010-0200",
  },
  {
    title: "Client Vehicle Owner Address",
    variable: "clientVehicleOwnerAddress",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "123 Main St, Los Angeles, CA 90001",
  },
  {
    title: "Client Vehicle Owner AddressLine1",
    variable: "clientVehicleOwnerAddressLine1",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "123 Main St",
  },
  {
    title: "Client Vehicle Owner AddressLine2",
    variable: "clientVehicleOwnerAddressLine2",
    type: "string",
    parent: "clientVehicle",
    exampleValue: "Los Angeles, CA 90001",
  },
  {
    title: "Defendant Vehicle Owner Name",
    variable: "defendantVehicleOwnerName",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "Alex Rivera",
  },
  {
    title: "Defendant Vehicle Owner FirstName",
    variable: "defendantVehicleOwnerFirstName",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "Alex",
  },
  {
    title: "Defendant Vehicle Owner LastName",
    variable: "defendantVehicleOwnerLastName",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "Rivera",
  },
  {
    title: "Defendant Vehicle Owner Email",
    variable: "defendantVehicleOwnerEmail",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "alex@example.com",
  },
  {
    title: "Defendant Vehicle Owner Phone",
    variable: "defendantVehicleOwnerPhone",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "(555) 010-0200",
  },
  {
    title: "Defendant Vehicle Owner Address",
    variable: "defendantVehicleOwnerAddress",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "123 Main St, Los Angeles, CA 90001",
  },
  {
    title: "Defendant Vehicle Owner AddressLine1",
    variable: "defendantVehicleOwnerAddressLine1",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "123 Main St",
  },
  {
    title: "Defendant Vehicle Owner AddressLine2",
    variable: "defendantVehicleOwnerAddressLine2",
    type: "string",
    parent: "defendantVehicle",
    exampleValue: "Los Angeles, CA 90001",
  },
];
